module.exports = __webpack_public_path__ + "assets/img/addimg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/addimg.svg
// module id = 452
// module chunks = 0